export const pessoaModel = {
  pessoa: function () {
    return {
      id: '',
      nm_pessoa: '',
      nr_cpfcnpj: '',
      tp_pessoa: '',
      pessoa_fisica: {
        id: '',
        dt_nascimento: '',
        nr_rg: '',
        tp_estadocivil: '',
        tp_genero: ''          
      },
      pessoa_juridica: {
        id: '',
        nm_razaoSocial: '',
        nm_abreviado: '',
        nm_fantasia: '',
      },
      enderecos: [],
      telefones: [],
      emails: []
    }
  },
}


// WEBPACK FOOTER //
// ./src/models/pessoa.js